import { render, staticRenderFns } from "./DormerMaterialFormStep.vue?vue&type=template&id=40ae8cdd"
import script from "./DormerMaterialFormStep.vue?vue&type=script&lang=js"
export * from "./DormerMaterialFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports